import axios from "axios"
import { BaseService } from "./base.service";
import { NoteList, Note } from "@/models/note.model";

class NoteService extends BaseService {

    constructor() {
        super();
        console.log("created a instance of NoteService");
    }

    async deleteNoteList(id: number){
        let result = await axios.delete(`${this.api}note/DeleteNoteList?id=${id}`);
        return result;
    }

    async createNoteList(noteList: NoteList){
        let result = await axios.post(`${this.api}note/CreateNoteList`, noteList);
        return result;
    }

    async updateNoteList(noteList: NoteList){
        let result = await axios.put(`${this.api}note/UpdateNoteList`, noteList);
        return result;
    }

    async getNoteLists(pinboardId:number){
        return axios.get(`${this.api}note/GetNoteListOnPinBoard?pinBoardId=${pinboardId }`).then(req => { return req.data });
    }

    async deleteNote(id: number){
        let result = await axios.delete(`${this.api}note/DeleteNote?id=${id}`);
        return result;
    }

    async createNote(note: Note){
        let result = await axios.post(`${this.api}note/CreateNote`, note);
        return result;
    }

    async updateNote(note: Note){
        let result = await axios.put(`${this.api}note/UpdateNote`, note);
        return result;
    }
}

export const noteService = new NoteService();

